<template lang="pug">
  div
    p.text-xs.font-semibold.uppercase.tracking-wider.text-supplement {{ label }}
    //- Padding matches app-kit's text inputs (px-5 py-4)
    div(class="mt-2 flex items-center rounded-lg border border-gray-400 bg-white pl-5 pr-2")
      Icon(icon="link", class="flex-shrink-0 text-supplement")
      a(:href="url", :title="url", target="_blank", rel="noopener", class="ml-3 min-w-0 flex-1 truncate py-4 font-medium text-primary-default hover:text-primary-hover hover:underline") {{ displayUrl }}
      button(
        type="button",
        v-clipboard="url",
        v-clipboard:success="onCopy",
        :class="accentClass",
        class="ml-3 inline-flex flex-shrink-0 items-center rounded-md px-4 py-2 font-semibold text-white transition-colors"
      )
        Icon(:icon="copied ? 'check' : 'copy'", class="mr-2")
        | {{ copied ? "Copied" : "Copy" }}
</template>

<script>
// Full class names are listed so Tailwind's JIT can find them.
const accents = {
  primary: "bg-primary-default hover:bg-primary-hover",
  secondary: "bg-secondary-default hover:bg-secondary-hover"
}

export default {
  props: {
    url: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    accent: {
      type: String,
      default: "primary",
      validator: value => Object.keys(accents).includes(value)
    }
  },
  data() {
    return {
      copied: false
    }
  },
  computed: {
    accentClass() {
      return accents[this.accent]
    },
    displayUrl() {
      return this.url.replace(/^https?:\/\//, "")
    }
  },
  beforeDestroy() {
    clearTimeout(this.copiedTimeout)
  },
  methods: {
    onCopy() {
      this.copied = true
      clearTimeout(this.copiedTimeout)
      this.copiedTimeout = setTimeout(() => (this.copied = false), 2000)
    }
  }
}
</script>
